import styled from 'styled-components'

export const CloseIconWrapper = styled.div`
  user-select: none;
  position: absolute;
  z-index: 1;
  width: 18px;
  height: 18px;
  top: 5px;
  right: 5px;
  background-color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border-radius: 5px;
  margin: 32px 32px 0px 0px;
  ${(props) => props.css}
`
